<template>
    <div class="extendable-card-list">
        <div
            class="extendable-card-list__card"
            v-for="(data, index) in cards"
            :key="'extendable-card-list-card-' + index"
        >
            <button
                class="extendable-card-list__delete"
                :title="trans('buttons.remove')"
                v-if="dataCanBeDeleted"
                @click.prevent="() => removeCard(index)"
            >
                &times;
            </button>
            <fieldset :disabled="!dataCanBeEdited">
                <slot v-bind:data="data" v-bind:index="index" :errors="errors">
                </slot>
            </fieldset>
        </div>

        <div class="extendable-card-list__empty" v-if="!cards.length">
            <alert type="info">
                {{ translatedSentenceWhenEmpty }}
            </alert>
        </div>

        <div class="extendable-card-list__add" v-if="dataCanBeAdded">
            <button @click.prevent="addCard" :title="trans('buttons.add')">
                <div class="icon-button icon-button--primary icon-button--text">
                    {{ trans('buttons.icon.add_element') }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'cards',
        event: 'update',
    },
    props: {
        cards: {
            type: Array,
            default: () => {
                return [];
            },
        },
        errors: {
            type: Object,
            default: () => {
                return {};
            },
        },
        newCardObject: {
            type: Object,
        },
        dataCanBeAdded: Boolean,
        dataCanBeDeleted: Boolean,
        dataCanBeEdited: Boolean,
        sendRemoveEvent: Boolean,
        sentenceWhenEmpty: String, // language.id
    },
    computed: {
        translatedSentenceWhenEmpty() {
            return this.trans(
                this.sentenceWhenEmpty || 'vuetables.label.noResults'
            );
        },
    },
    methods: {
        removeCard(index) {
            const newCards = this.cards.slice(0);
            newCards.splice(index, 1);
            this.$emit('update', newCards);
            if (this.sendRemoveEvent) {
                this.$emit('remove');
            }
        },

        addCard() {
            const newCards = this.cards.slice();
            newCards.push(this.newCardObject || {});
            this.$emit('update', newCards);
        },
    },
};
</script>
